import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setStorageItem } from "../utils/localStorage";
import { DURATION_TOAST } from "../utils/costants";
import { useToastAlert } from "../components/ToastAlert/ToastAlert";
import { RoutesRouter } from "../models/Routes";
import { useEndpoints } from "./useEndpoints";

export interface IAxiosLoginError {
  message?: string;
  invalidFields?: IInvalidField;
  error?: string;
}

interface IInvalidField {
  email?: string[];
  password?: string[];
}

export const useLogin = () => {
  const { login, me } = useEndpoints();
  const toastAlert = useToastAlert();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [errors, setErrors] = useState<IInvalidField>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchLogin = async (body: Record<"email" | "password", string>) => {
    setIsLoading(true);
    try {
      const response = await login(body);
      const resp = await response.json();
      if (response.status === 200) {
        setStorageItem("token", { ...resp, date: new Date() });
        const responseMe = await me();
        const respMe = await responseMe.json();
        if (responseMe.status === 200) {
          if (respMe.role === "SUPER_ADMIN") {
            setStorageItem("me", { ...respMe });
            toastAlert.showToast({
              message: "Loggato con successo",
              subMessage: "ok",
              type: "success",
              duration: DURATION_TOAST,
            });
            navigate(RoutesRouter.companies);
          } else
            toastAlert.showToast({
              message: "Invalid credential",
              subMessage: "Invalid credential",
              type: "error",
              duration: DURATION_TOAST,
            });
        }
      }
      if (response.status === 401) {
        toastAlert.showToast({
          message: "Invalid credential",
          subMessage: "Invalid credential",
          type: "error",
          duration: DURATION_TOAST,
        });
      }
      if (response.status === 403) {
        toastAlert.showToast({
          message: t("login.error.forbidden"),
          subMessage: resp.message || "User is not allowed to login",
          type: "error",
          duration: DURATION_TOAST,
        });
      }

      return resp;
    } catch (errorRequest: any) {
      console.log("e", errorRequest);

      if (errorRequest.response.status >= 500) {
        toastAlert.showToast({
          message: "Internal error",
          subMessage: "Sorry! Internal server error",
          type: "error",
          duration: DURATION_TOAST,
        });
        return;
      }
      const e = errorRequest;

      const message = e.response?.data?.message;
      const error = e.response?.data?.error;
      const invalidFields = e.response?.data?.invalidFields;

      invalidFields &&
        setErrors({
          email: invalidFields.email ?? [],
          password: invalidFields.password ?? [],
        });
      message && error && !invalidFields
        ? toastAlert.showToast({
            message,
            subMessage: error,
            type: "error",
            duration: DURATION_TOAST,
          })
        : toastAlert.showToast({
            message: t("errorsToast.InternalServerError.title"),
            subMessage: t(
              "errorsToast.InternalServerError.description"
            ) as string,
            type: "error",
            duration: DURATION_TOAST,
          });
    } finally {
      setIsLoading(false);
    }
  };

  return { fetchLogin, errors, isLoading };
};
